<template>
  <div class="login-panel show-email show-password-form">
    <template v-if="!canJoinEventByTime">
      <div v-if="context.ADD_CUSTOM_CLOSE_TEXT" v-html="context.CUSTOM_CLOSE_TEXT"></div>
      <div v-else>Access to this event is now closed</div>
    </template>
    <template v-else>
      <div v-if="backRoute" class="back-button">
        <router-link :to="{ name: backRoute }"><i class="fa fa-fw fa-arrow-left"></i>&nbsp;Back</router-link>
      </div>
      <div v-if="context.LOGIN_HEADER_IS_CUSTOM" v-html="context.LOGIN_HEADER" class="login-header"></div>
      <div v-else class="login-header">
        <div class="welcome">Welcome to</div>
        <div class="title">{{ context.TITLE }}</div>
      </div>
      <CountdownTimer v-if="!isEventStarted && context.RESTRICT_ACCESS_FOR_ATTENDEES"></CountdownTimer>
      <p class="subtitle">{{ pageSubtitle }}</p>
      <slot></slot>
    </template>
  </div>
</template>

<script>
import CountdownTimer from "../CountdownTimer";
import { mapGetters, mapState } from "vuex";
import { ROUTES } from "@/helpers/constants";

export default {
  name: "AuthTile",
  components: {
    CountdownTimer
  },
  computed: {
    ...mapState("event", ["context"]),
    ...mapState("users", ["userInfo", "user"]),
    ...mapGetters("config", ["isEventStarted", "canJoinEventByTime"]),
    pageSubtitle() {
      switch (this.$route.name) {
        case ROUTES.DIGITAL_EVENT_AUTH_LOGIN:
          return "Guest check-in";
        case ROUTES.DIGITAL_EVENT_AUTH_SET_PASSWORD:
          return `Hi ${this.firstName} ${this.lastName},`;
        case ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_ACCOUNT:
          return "Create account";
        case ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD:
        case ROUTES.DIGITAL_EVENT_AUTH_SET_NEW_PASSWORD:
          return "Update Password";
        case ROUTES.DIGITAL_EVENT_AUTH_RESET_TEMP_PASSWORD:
          return "Reset password";
        case ROUTES.DIGITAL_EVENT_AUTH_TABLE_INFO:
          return `Welcome ${this.firstName}`;
        default:
          return "";
      }
    },
    firstName() {
      if (this.user && this.user.profile && this.user.profile.firstName) {
        return this.user.profile.firstName;
      } else if (this.userInfo) {
        return this.userInfo.firstName;
      } else if (this.user) {
        return this.user.user_firstname;
      }
      return null;
    },
    lastName() {
      if (this.user && this.user.profile && this.user.profile.lastName) {
        return this.user.profile.lastName;
      } else if (this.userInfo) {
        return this.userInfo.lastName;
      } else if (this.user) {
        return this.user.user_lastname;
      }
      return null;
    },
    backRoute() {
      switch (this.$route.name) {
        case ROUTES.DIGITAL_EVENT_AUTH_SET_PASSWORD:
        case ROUTES.DIGITAL_EVENT_AUTH_CREATE_ACCOUNT:
          return ROUTES.DIGITAL_EVENT_AUTH_LOGIN;
        case ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_ACCOUNT:
          return ROUTES.DIGITAL_EVENT_AUTH;
        case ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD:
        case ROUTES.DIGITAL_EVENT_AUTH_RESET_TEMP_PASSWORD:
          return ROUTES.DIGITAL_EVENT_AUTH_SET_PASSWORD;
        case ROUTES.DIGITAL_EVENT_AUTH_SET_NEW_PASSWORD:
          return ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD;
        default:
          return null;
      }
    }
  }
};
</script>
